import { render, staticRenderFns } from "./addTab.vue?vue&type=template&id=79ec3f06&ref=addTab&"
import script from "./addTab.vue?vue&type=script&lang=js&"
export * from "./addTab.vue?vue&type=script&lang=js&"
import style0 from "./addTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports